import {
  BASICSHARED_LOADED,
  DEMO_LANDLORD,
  ERROR_RESOLVE,
  FULLSHARED_LOADED,
  LANDLORD_LOADED,
  LOAD_PROPERTY,
  LOAD_PROPERTY_ALL,
  PROPERTY_ADDED,
  PROPERTY_DELETED,
  PROPERTY_EDITED,
  PROPERTY_ERROR,
  PROPERTY_LOADED,
  SET_PROPERTY,
  SHARED_PROFILE_FAILED_LOADING,
  TOGGLE_LOADING,
  IS_PARENT_LL,
  LOAD_POLICY_DETAILS,
  SET_DEA_WORKSPACE,
  SET_ALMOND_WORKSPACE,
  SET_CATELLA_WORKSPACE,
  SET_CAPACITY_REPORT_WORKSPACE,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case LANDLORD_LOADED:
      return {
        ...state,
        landlords: action.payload,
      };

    case TOGGLE_LOADING:
      return {
        ...state,
        landlord_loading: action.payload,
      };
    case PROPERTY_LOADED:
      return {
        ...state,
        properties: [...state.properties, action.payload],
      };
    case LOAD_PROPERTY:
      return {
        ...state,
        landlord_loading: false,
        properties: action.payload,
      };
    case LOAD_PROPERTY_ALL:
      return {
        ...state,
        landlord_loading: false,
        propertiesAll: action.payload,
      };
    case IS_PARENT_LL:
      return {
        ...state,
        landlord_loading: false,
        isParentLL: action.payload,
      };
    case SET_PROPERTY:
      return {
        ...state,
        current_property: action.payload,
      };
    case PROPERTY_ADDED:
      return {
        ...state,
        landlord_loading: false,
        properties: action.payload,
      };

    case PROPERTY_EDITED:
      return {
        ...state,
        landlord_loading: false,
      };

    case PROPERTY_DELETED:
      return {
        ...state,
        landlord_loading: false,
        properties: state.properties.filter(
          (property) => property._id !== action.payload
        ),
      };

    case PROPERTY_ERROR:
      return {
        ...state,
        landlord_loading: false,
        landlord_error: action.payload,
      };

    case ERROR_RESOLVE:
      return {
        ...state,
        landlord_loading: false,
        landlord_error: null,
      };

    case FULLSHARED_LOADED:
      return {
        ...state,
        fullProfileReceived: action.payload,
      };

    case BASICSHARED_LOADED:
      return {
        ...state,
        basicProfileReceived: action.payload,
      };
    case SHARED_PROFILE_FAILED_LOADING:
      return {
        ...state,
      };
    case LOAD_POLICY_DETAILS:
      return {
        ...state,
        customPolicyDetails: action.payload,
      };
    case SET_DEA_WORKSPACE:
      return {
        ...state,
        deaWorkspace: action.payload,
      };
    case SET_ALMOND_WORKSPACE:
      return {
        ...state,
        almondWorkspace: action.payload,
      };
    case SET_CATELLA_WORKSPACE:
      return {
        ...state,
        catellaWorkspace: action.payload,
      };
    case SET_CAPACITY_REPORT_WORKSPACE:
      return {
        ...state,
        capacityReportWorkspace: action.payload,
      };

    default:
      return state;
  }
};
